<section class="page">
  <header class="page-header">
    <h2>Résultat des analyses</h2>
    <p class="subtitle">Toutes les analyses paginées avec leurs fichiers, départements, résultats et hash associés.</p>
  </header>

  <section class="panel">
    <div class="toolbar">
      <div class="filter-group">
        <label for="analysis-search">Filtrer toutes les colonnes</label>
        <input
          #searchInput
          id="analysis-search"
          type="text"
          [value]="searchTerm"
          placeholder="Hash, fichier, cartouche, département..."
          (keyup.enter)="applySearch(searchInput.value)"
        />
      </div>
      <div class="toolbar-actions">
        <button type="button" (click)="applySearch(searchInput.value)" [disabled]="loading">
          {{ loading ? 'Chargement...' : 'Filtrer' }}
        </button>
        <button type="button" class="secondary" (click)="clearSearch(searchInput)" [disabled]="loading || !searchTerm">
          Réinitialiser
        </button>
        <button type="button" (click)="refresh()" [disabled]="loading">
          Actualiser
        </button>
        <button type="button" class="secondary" (click)="downloadAllResultFilesZip()" [disabled]="loading || downloadingResultsZip">
          {{ downloadingResultsZip ? 'Préparation du ZIP...' : 'Tout télécharger (ZIP)' }}
        </button>
      </div>
    </div>

    @if (error) {
      <p class="error">{{ error }}</p>
    }

    @if (loading) {
      <p class="meta">Chargement des analyses...</p>
    } @else if (items.length === 0) {
      <p class="meta">Aucune analyse trouvée.</p>
    } @else {
      <p class="meta">{{ totalCount }} analyse(s) trouvée(s) - page {{ currentPage }} / {{ totalPages }}</p>
      <div class="table-wrap">
        <table class="analysis-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Fichiers de départ</th>
              <th>Type de pipe</th>
              <th>Méthode de tri</th>
              <th>Cartouches</th>
              <th>Départements</th>
              <th>Résultat Pipe Antagène</th>
              <th>Hash</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (item of items; track item.id) {
              <tr>
                <td>{{ item.dateLabel }}</td>
                <td>
                  @if (item.fichiersDepart.length === 0) {
                    -
                  } @else {
                    <div class="file-list">
                      @for (fichier of item.fichiersDepart; track fichier.label) {
                        @if (fichier.href) {
                          <a [href]="fichier.href">{{ fichier.label }}</a>
                        } @else {
                          <span>{{ fichier.label }}</span>
                        }
                      }
                    </div>
                  }
                </td>
                <td>{{ item.typePipeLabel }}</td>
                <td>{{ item.methodeTriLabel }}</td>
                <td>{{ item.cartouchesLabel || '-' }}</td>
                <td>{{ item.departementsLabel || '-' }}</td>
                <td>
                  @if (item.typePipeNom === 'antagene') {
                    @if (item.cartoucheResultats.length === 0) {
                      -
                    } @else {
                      <div class="cartouche-results">
                        @for (cartouche of item.cartoucheResultats; track cartouche.fichierResultatLabel) {
                          <div class="cartouche-result-item">
                            @if (cartouche.href) {
                              <a [href]="cartouche.href">{{ cartouche.fichierResultatLabel }}</a>
                            } @else {
                              <span>{{ cartouche.fichierResultatLabel }}</span>
                            }
                          </div>
                        }
                      </div>
                    }
                  } @else {
                    N/A
                  }
                </td>
                <td>{{ item.hashLabel }}</td>
                <td class="actions">
                  <button
                    type="button"
                    class="btn-delete"
                    [disabled]="deletingAnalyseIds.has(item.id) || loading"
                    (click)="deleteAnalyse(item.id)"
                    title="Supprimer cette analyse et ses fichiers associés"
                  >
                    {{ deletingAnalyseIds.has(item.id) ? 'Suppression...' : 'Supprimer' }}
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <div class="pagination">
        <button type="button" (click)="previousPage()" [disabled]="loading || currentPage <= 1">Page précédente</button>
        <span>Page {{ currentPage }} / {{ totalPages }}</span>
        <button type="button" (click)="nextPage()" [disabled]="loading || currentPage >= totalPages">Page suivante</button>
      </div>
    }
  </section>
</section>
